// [2026-01-12] covrfly-upsell PROD - v1.5.2 (Copy + hierarchy polish)
// Production: no console logs, safe init, safe fetch wrapper, strict CSS scoping.
(function () {
  "use strict";

  // --- Singleton guard (production) ---
  if (window.__COVRFLY_UPSELL_PROD__?.running) return;
  window.__COVRFLY_UPSELL_PROD__ = window.__COVRFLY_UPSELL_PROD__ || {};
  window.__COVRFLY_UPSELL_PROD__.running = true;

  const CONFIG = {
    selectors: {
      container: "#covrfly-shipping-badge",
      text: "p.covrfly-shipping-text",
      myBar: '[data-covrfly-upsell="1"]',
    },
    stylesId: "covrfly-upsell-style",
    productType: "Phone Case",
    endpoints: ["/cart/add", "/cart/change", "/cart/update", "/cart/clear", "/cart.js"],
    colors: {
      fillGradient:
        "linear-gradient(90deg, rgba(8,200,85,0.35) 0%, rgba(8,200,85,0.85) 55%, #08c855 100%)",
      track: "rgba(0,0,0,0.06)",
      border: "rgba(0,0,0,0.08)",
      bg: "#ffffff",
      textMain: "rgba(0,0,0,0.90)",
      textSec: "rgba(0,0,0,0.82)",
      accent: "#08c855",
      pillBg: "rgba(0,0,0,0.04)",
      pillBorder: "rgba(0,0,0,0.10)",
    },
    shakeCooldown: 10000,
    burstDelay: 1800,
    maxBurst: 2,
    visibilityRatio: 0.4,
    debounceMs: 200,
  };

  const PATCH_ID = "covrfly_upsell_" + Date.now() + "_" + Math.random().toString(16).slice(2);
  const prePatchFetchRef = window.fetch;

  let isRunning = true;

  let debounceTimer = null;
  let burstTimer = null;
  let domObserver = null;
  let observer = null;

  let lastHTML = "";
  let lastBurstTime = 0;
  let pendingShake = false;
  let isElementVisible = false;
  let currentBurstCount = 0;

  function prefersReducedMotion() {
    try {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch {
      return false;
    }
  }

  // --- CSS injection (scoped) ---
  function injectStyles() {
    if (document.getElementById(CONFIG.stylesId)) return;

    const css = `
${CONFIG.selectors.container} {
  background-color: ${CONFIG.colors.bg} !important;
  border: 1px solid ${CONFIG.colors.border} !important;
  border-radius: 16px !important;
  padding: 12px 14px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 14px !important; /* más aire sin cambiar el diseño */
  box-shadow: 0 4px 12px rgba(0,0,0,0.03) !important;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  margin: 0 !important;
}

${CONFIG.selectors.container} p.covrfly-shipping-text {
  margin: 0 auto !important;
  padding: 0 !important;
  font-family: inherit;
  font-weight: 600 !important; /* vuelve a la sensación original */
  font-size: 15px !important;
  line-height: 1.46 !important; /* más interlineado */
  letter-spacing: -0.2px !important;
  color: ${CONFIG.colors.textMain} !important;
  text-align: center !important;
  max-width: 320px !important;
  text-wrap: balance;
}

/* Líneas: cada renglón respira */
${CONFIG.selectors.container} .covrfly-line {
  display: block;
  width: 100%;
  margin-top: 10px; /* más aire real */
}
${CONFIG.selectors.container} .covrfly-line:first-of-type {
  margin-top: 0;
}

${CONFIG.selectors.container} .covrfly-line.primary {
  font-weight: 600;
  color: ${CONFIG.colors.textMain};
}

${CONFIG.selectors.container} .covrfly-line.secondary {
  font-weight: 600;            /* NO minimizar */
  color: ${CONFIG.colors.textSec};
}

/* Highlight premium para tier máximo */
${CONFIG.selectors.container} .covrfly-standard-highlight{
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(8,200,85,0.08);
  border: 1px solid rgba(8,200,85,0.20);
  font-weight: 600;
  color: ${CONFIG.colors.textMain};
}

${CONFIG.selectors.container} .covrfly-accent-plus {
  color: ${CONFIG.colors.accent};
  font-weight: 700;
}

/* Pills OFF y "activado" (neutral premium) */
${CONFIG.selectors.container} .covrfly-pill {
  background-color: ${CONFIG.colors.pillBg};
  border: 1px solid ${CONFIG.colors.pillBorder};
  color: inherit;
  padding: 1px 6px;
  border-radius: 10px;
  display: inline-block;
  position: relative;
  top: -1px;
  font-weight: 600;
  white-space: nowrap;
  font-size: 0.95em;
}

/* “Agrega 1 más” (NO link, NO subrayado) */
${CONFIG.selectors.container} .covrfly-next-step {
  text-decoration: none !important;
  cursor: default !important;
  color: inherit;
  font-weight: 700;
  white-space: nowrap;
}

/* Micro-pulse premium (respira, no parpadea) */
@keyframes covrflyBreath {
  0% { transform: scale(1); }
  50% { transform: scale(1.03); }
  100% { transform: scale(1); }
}
${CONFIG.selectors.container} .covrfly-pulse {
  animation: covrflyBreath 4.8s infinite ease-in-out;
  display: inline-block;
  will-change: transform;
}

/* Barra */
${CONFIG.selectors.container} .covrfly-upsell-track {
  width: 100%;
  height: 6px;
  background-color: ${CONFIG.colors.track};
  border-radius: 100px;
  overflow: hidden;
  position: relative;
  transform: translateZ(0);
}

${CONFIG.selectors.container} .covrfly-upsell-fill {
  height: 100%;
  width: 0%;
  background: ${CONFIG.colors.fillGradient};
  border-radius: 100px;
  transition: width 0.6s cubic-bezier(0.25, 1, 0.5, 1), background 0.3s ease;
  position: relative;
}

${CONFIG.selectors.container} .covrfly-upsell-fill.covrfly-shimmer::after {
  content: "";
  position: absolute;
  top: 0; left: 0; bottom: 0; right: 0;
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.2) 50%,
    rgba(255,255,255,0) 100%
  );
  transform: skewX(-20deg) translateX(-150%);
  animation: covrflyShimmer 2.6s infinite;
}

${CONFIG.selectors.container} .covrfly-upsell-fill.covrfly-shimmer.covrfly-calm::after {
  animation-duration: 3.5s;
  opacity: 0.14;
}

${CONFIG.selectors.container} p.covrfly-shipping-text.covrfly-nudge-anim {
  animation: covrflyNudge 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

${CONFIG.selectors.container}.covrfly-shake {
  animation: covrflyShake 1.2s ease-out;
  transition: none !important;
}

@keyframes covrflyShimmer {
  0%   { transform: skewX(-20deg) translateX(-150%); }
  100% { transform: skewX(-20deg) translateX(250%); }
}

@keyframes covrflyNudge {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.02); }
  100% { transform: scale(1); }
}

@keyframes covrflyShake {
  0%, 100% { transform: translateX(0); }
  10% { transform: translateX(-2px); }
  20% { transform: translateX(2px); }
  30% { transform: translateX(-2px); }
  40% { transform: translateX(1.5px); }
  50% { transform: translateX(-1.5px); }
  60% { transform: translateX(1px); }
  70% { transform: translateX(-1px); }
  80% { transform: translateX(0.5px); }
  90% { transform: translateX(-0.5px); }
}

@media (prefers-reduced-motion: reduce) {
  ${CONFIG.selectors.container} .covrfly-upsell-fill { transition: none !important; }
  ${CONFIG.selectors.container} .covrfly-upsell-fill.covrfly-shimmer::after { animation: none !important; display: none; }
  ${CONFIG.selectors.container} p.covrfly-shipping-text.covrfly-nudge-anim,
  ${CONFIG.selectors.container}.covrfly-shake,
  ${CONFIG.selectors.container} .covrfly-pulse { animation: none !important; }
}
    `.trim();

    // Duplicar estilos para el clone dentro del cart drawer
    const drawerCss = css.split('#covrfly-shipping-badge').join('#covrfly-shipping-badge-drawer');

    const style = document.createElement("style");
    style.id = CONFIG.stylesId;
    style.textContent = css + "\n" + drawerCss;
    document.head.appendChild(style);
  }

  async function getCart(fetchFn) {
    try {
      const res = await fetchFn(`/cart.js?covrfly_upsell=${Date.now()}`);
      if (!res || !res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function calculate(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;

    let count = 0;
    for (const item of cart.items) {
      if (item && item.product_type === CONFIG.productType) {
        count += Number(item.quantity || 0);
      }
    }

    if (count === 0 && Number(cart.item_count || 0) > 0) {
      count = Number(cart.item_count || 0);
    }

    const pill15 = '<span class="covrfly-pill">15% OFF</span>';
    const pill20 = '<span class="covrfly-pill">20% OFF</span>';
    const pill25 = '<span class="covrfly-pill">25% OFF</span>';
    const nextStep = '<span class="covrfly-next-step covrfly-pulse">Agrega 1 más</span>';

    let html = "";
    let pct = 0;

    if (count <= 1) {
      html = `
<span class="covrfly-line primary">${nextStep} para ${pill15} en tu pedido</span>
<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Envío sin costo</span>
      `.trim();
      pct = 25;
    } else if (count === 2) {
      html = `
<span class="covrfly-line primary">Ya tienes ${pill15} en tu pedido</span>
<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Envío sin costo</span>
<span class="covrfly-line">${nextStep} para ${pill20}</span>
      `.trim();
      pct = 50;
    } else if (count === 3) {
      html = `
<span class="covrfly-line primary">Ya tienes ${pill20} en tu pedido</span>
<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Envío sin costo</span>
<span class="covrfly-line">${nextStep} para ${pill25}</span>
      `.trim();
      pct = 75;
    } else {
      html = `
<span class="covrfly-line primary">Ya tienes ${pill25} en tu pedido</span>
<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Envío sin costo</span>
<span class="covrfly-line primary"><span class="covrfly-standard-highlight">25% OFF en cada case extra</span></span>
      `.trim();
      pct = 100;
    }

    return { count, pct, html };
  }

  function findScrollParent(element) {
    let parent = element.parentElement;
    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      const isScrollable = ["auto", "scroll", "overlay"].includes(overflowY);
      const hasScroll = parent.scrollHeight - parent.clientHeight > 20;
      if (isScrollable && hasScroll) return parent;
      parent = parent.parentElement;
    }
    parent = element.parentElement;
    while (parent) {
      if (parent.scrollHeight - parent.clientHeight > 20) return parent;
      parent = parent.parentElement;
    }
    return null;
  }

  function triggerShake(container) {
    if (!isRunning || !isElementVisible) return;
    if (prefersReducedMotion()) return;

    container.classList.remove("covrfly-shake");
    void container.offsetWidth;
    container.classList.add("covrfly-shake");

    setTimeout(() => {
      try { container.classList.remove("covrfly-shake"); } catch {}
    }, 1250);
  }

  function attemptBurst(container) {
    const now = Date.now();
    const canStartBurst = pendingShake || now - lastBurstTime > CONFIG.shakeCooldown;
    if (!canStartBurst) return;

    lastBurstTime = now;
    pendingShake = false;
    currentBurstCount = 0;

    triggerShake(container);
    currentBurstCount++;

    if (burstTimer) clearTimeout(burstTimer);
    burstTimer = setTimeout(() => {
      if (!isRunning || !isElementVisible) return;
      if (prefersReducedMotion()) return;
      if (currentBurstCount < CONFIG.maxBurst) {
        triggerShake(container);
        currentBurstCount++;
      }
    }, CONFIG.burstDelay);
  }

  function setupObserver(container) {
    if (observer) observer.disconnect();
    const root = findScrollParent(container);

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const intersecting = entry.intersectionRatio >= CONFIG.visibilityRatio;

          if (intersecting && !isElementVisible) {
            isElementVisible = true;
            currentBurstCount = 0;
            attemptBurst(entry.target);
          } else if (!intersecting) {
            isElementVisible = false;
            if (burstTimer) clearTimeout(burstTimer);
          }
        }
      },
      { root, threshold: [0, CONFIG.visibilityRatio, 1] }
    );

    observer.observe(container);
  }

  function cleanSiblings(container) {
    Array.from(container.children).forEach((child) => {
      if (child.matches(CONFIG.selectors.text)) return;
      if (child.hasAttribute("data-covrfly-upsell")) return;
      try { child.remove(); } catch {}
    });

    container.querySelectorAll("hr, progress, [role='progressbar']").forEach((el) => {
      if (!el.closest(CONFIG.selectors.myBar)) {
        try { el.remove(); } catch {}
      }
    });

    container.querySelectorAll("*").forEach((el) => {
      if (el.closest(CONFIG.selectors.myBar)) return;
      const cls = (el.className || "").toString().toLowerCase();
      if (cls.includes("progress") || cls.includes("bar") || cls.includes("divider") || cls.includes("separator")) {
        try { el.remove(); } catch {}
      }
    });

    const myBars = container.querySelectorAll(CONFIG.selectors.myBar);
    if (myBars.length > 1) {
      for (let i = 1; i < myBars.length; i++) {
        try { myBars[i].remove(); } catch {}
      }
    }
  }

  function render(data) {
    // Renderizar en el contenedor original (si existe — /cart o PDP)
    const container = document.querySelector(CONFIG.selectors.container);
    if (container) {
      cleanSiblings(container);

      let textEl = container.querySelector(CONFIG.selectors.text);
      if (!textEl) {
        textEl = document.createElement("p");
        textEl.className = "covrfly-shipping-text";
        container.prepend(textEl);
      }

      let track = container.querySelector(CONFIG.selectors.myBar);
      if (!track) {
        track = document.createElement("div");
        track.className = "covrfly-upsell-track";
        track.setAttribute("data-covrfly-upsell", "1");
        track.innerHTML = '<div class="covrfly-upsell-fill"></div>';
        container.appendChild(track);
        setupObserver(container);
      } else if (!observer) {
        setupObserver(container);
      }

      const fill = track.firstElementChild;

      if (textEl.innerHTML !== data.html) {
        textEl.innerHTML = data.html;

        if (lastHTML !== "") {
          textEl.classList.remove("covrfly-nudge-anim");
          void textEl.offsetWidth;
          textEl.classList.add("covrfly-nudge-anim");
        }
        lastHTML = data.html;

        if (!isElementVisible) pendingShake = true;

        // Shimmer solo 800ms al cambiar de nivel
        fill.classList.remove("covrfly-shimmer");
        void fill.offsetWidth;
        fill.classList.add("covrfly-shimmer");
        setTimeout(() => {
          try { fill.classList.remove("covrfly-shimmer"); } catch {}
        }, 800);

        // Celebración nivel máximo: highlight verde en borde
        if (data.pct >= 100) {
          fill.style.transition = 'width 0.18s ease-out';
          container.style.transition = 'box-shadow 0.3s ease';
          container.style.boxShadow = '0 0 0 2px #08c855';
          setTimeout(() => {
            container.style.boxShadow = '';
            fill.style.transition = '';
          }, 600);
        }
      }

      fill.style.width = `${data.pct}%`;
      fill.style.background = CONFIG.colors.fillGradient;
    }

    // TAMBIÉN renderizar en el cart drawer (independiente del original)
    renderDrawerBadge(data);
  }

  let lastDrawerHTML = "";

  function renderDrawerBadge(data) {
    const dc = document.getElementById("covrfly-shipping-badge-drawer");
    if (!dc) return;

    let textEl = dc.querySelector("p.covrfly-shipping-text");
    if (!textEl) {
      textEl = document.createElement("p");
      textEl.className = "covrfly-shipping-text";
      dc.prepend(textEl);
    }

    let track = dc.querySelector('[data-covrfly-upsell="1"]');
    if (!track) {
      track = document.createElement("div");
      track.className = "covrfly-upsell-track";
      track.setAttribute("data-covrfly-upsell", "1");
      track.innerHTML = '<div class="covrfly-upsell-fill"></div>';
      dc.appendChild(track);
    }

    const fill = track.firstElementChild;

    // Nudge + shake + shimmer cuando el contenido cambia
    if (textEl.innerHTML !== data.html) {
      textEl.innerHTML = data.html;

      if (lastDrawerHTML !== "" && !prefersReducedMotion()) {
        textEl.classList.remove("covrfly-nudge-anim");
        void textEl.offsetWidth;
        textEl.classList.add("covrfly-nudge-anim");

        dc.classList.remove("covrfly-shake");
        void dc.offsetWidth;
        dc.classList.add("covrfly-shake");
        setTimeout(() => {
          try { dc.classList.remove("covrfly-shake"); } catch {}
        }, 1250);
      }

      lastDrawerHTML = data.html;

      // Shimmer solo 800ms al cambiar de nivel
      fill.classList.remove("covrfly-shimmer");
      void fill.offsetWidth;
      fill.classList.add("covrfly-shimmer");
      setTimeout(() => {
        try { fill.classList.remove("covrfly-shimmer"); } catch {}
      }, 800);

      // Celebración nivel máximo: highlight verde en borde
      if (data.pct >= 100) {
        fill.style.transition = 'width 0.18s ease-out';
        dc.style.transition = 'box-shadow 0.3s ease';
        dc.style.boxShadow = '0 0 0 2px #08c855';
        setTimeout(() => {
          dc.style.boxShadow = '';
          fill.style.transition = '';
        }, 600);
      }
    }

    fill.style.width = `${data.pct}%`;
    fill.style.background = CONFIG.colors.fillGradient;
  }

  async function update(fetchFn) {
    if (!isRunning) return;
    const cart = await getCart(fetchFn);
    if (!cart) return;
    const data = calculate(cart);
    if (!data) return;
    render(data);
  }

  function startWatch() {
    const currentFetchRef = window.fetch;
    const boundCurrentFetch = currentFetchRef.bind(window);

    function patchedFetch(input, init) {
      const result = boundCurrentFetch(input, init);

      let url = "";
      try {
        if (input instanceof Request) url = input.url;
        else if (typeof input === "string") url = input;
        else if (input && typeof input.url === "string") url = input.url;
      } catch {}

      if (url && CONFIG.endpoints.some((ep) => url.includes(ep)) && !url.includes("covrfly_upsell=")) {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          Promise.resolve(result)
            .then(() => update(boundCurrentFetch))
            .catch(() => {});
        }, CONFIG.debounceMs);
      }

      return result;
    }

    patchedFetch.covrflyId = PATCH_ID;
    window.fetch = patchedFetch;
  }

  function start() {
    injectStyles();
    startWatch();

    const boundFetch = window.fetch.bind(window);
    update(boundFetch);

    if (domObserver) domObserver.disconnect();
    domObserver = new MutationObserver(() => {
      const el = document.querySelector(CONFIG.selectors.container);
      if (el) {
        try { update(boundFetch); } catch {}
      }
    });
    domObserver.observe(document.documentElement, { childList: true, subtree: true });

    // Escuchar evento custom del cart drawer para actualizar la barrita
    document.addEventListener('covrfly:cart-updated', function (e) {
      if (e.detail && e.detail.cart) {
        const data = calculate(e.detail.cart);
        if (data) render(data);
      } else {
        update(prePatchFetchRef);
      }
    });

    window.__COVRFLY_UPSELL_PROD__.stop = function () {
      isRunning = false;

      if (window.fetch && window.fetch.covrflyId === PATCH_ID) {
        window.fetch = prePatchFetchRef;
      }

      if (debounceTimer) clearTimeout(debounceTimer);
      if (burstTimer) clearTimeout(burstTimer);

      if (observer) observer.disconnect();
      if (domObserver) domObserver.disconnect();

      const style = document.getElementById(CONFIG.stylesId);
      if (style) style.remove();

      document.querySelectorAll(CONFIG.selectors.myBar).forEach((b) => {
        try { b.remove(); } catch {}
      });

      window.__COVRFLY_UPSELL_PROD__.running = false;
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();